import * as actions from './actions';

export type State = {
  loading: boolean;
  error: Record<string, string>;
  accounts: Array<Record<string, any>>;
};

export default (
  state: any = {
    error: {},
  },
  action: any = {},
): State => {
  switch (action.type) {
    case actions.FETCH_RI_SCENARIO:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_RI_SCENARIO_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case actions.FETCH_RI_SCENARIO_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case actions.POST_SIMULATION:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};
